import { AxiosInstance } from 'axios';
import { DataFetcherResponse } from '@/compiler/types';
import baseAxios from '@/helpers/forms/axios';

// The directory is not in the committed OpenAPI bundle yet, so its wire type stays hand-written.
export interface PartnerAppDirectoryEntry {
    id: string
    name: string
    description: string | null
    logoUrl: string | null
    websiteUrl: string | null
    installUrl: string | null
}

export default (axios: AxiosInstance = baseAxios): {
    fetchDirectory: (page: number, perPage: number, signal?: AbortSignal) => Promise<DataFetcherResponse<PartnerAppDirectoryEntry>>
} => ({
    fetchDirectory: async (page: number, perPage: number, signal?: AbortSignal): Promise<DataFetcherResponse<PartnerAppDirectoryEntry>> => {
        const response = await axios.get<DataFetcherResponse<PartnerAppDirectoryEntry>>('/api/partner-apps/directory', {
            params: { page, perPage },
            signal,
        });

        return response.data;
    },
});
